import { configureStore } from "@reduxjs/toolkit";
import { recsApi } from "../services/recommendations";
// import { authApi } from "../services/authentication";
import { smartSearchApi } from "../services/smartSearch";
import { widgetSettingsApi } from "../services/widgetsSettings";
import { userSlice, widgetsSlice } from "../slices";
import { trackerApi } from "../services/tracker";
// import logger from "redux-logger";

const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    widgets: widgetsSlice.reducer,
    [recsApi.reducerPath]: recsApi.reducer,
    // [authApi.reducerPath]: authApi.reducer,
    [smartSearchApi.reducerPath]: smartSearchApi.reducer,
    [widgetSettingsApi.reducerPath]: widgetSettingsApi.reducer,
    [trackerApi.reducerPath]: trackerApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      // logger,
      recsApi.middleware,
      // authApi.middleware,
      smartSearchApi.middleware,
      widgetSettingsApi.middleware,
      trackerApi.middleware
    ),
});

export default store;
